import { BrxLink } from '@mediashop/app/bloomreach/types';
import { SKIP_RENDER } from '@mediashop/app/constants/semanticConstants';
import BurgerMenuQuickLinksItem from './BurgerMenuQuickLinksItem';
import { BurgerMenuQuickLinksProps } from './index';

const componentName = 'burger-menu-quick-links';

const BurgerMenuQuickLinks = ({ closeBurgerMenu, quickLinks }: BurgerMenuQuickLinksProps) => {
    const links = quickLinks
        .filter((quickLink) => !quickLink.hide)
        .filter((quickLink) => (quickLink.link as BrxLink).reference.length);

    if (!links.length) {
        return SKIP_RENDER;
    }

    return (
        <div className={`${componentName}`}>
            <ul className={`${componentName}__list`}>
                {links.map((quickLink) => (
                    <BurgerMenuQuickLinksItem
                        key={(quickLink.link as BrxLink).text}
                        closeBurgerMenu={closeBurgerMenu}
                        quickLink={quickLink}
                    />
                ))}
            </ul>
        </div>
    );
};

export default BurgerMenuQuickLinks;
